import React from 'react';
import { inject, observer } from 'mobx-react';
import './index.scss';

import CustomSnackbar from '../../components/global/snackbar'

import {toJS} from 'mobx';

import Icon from '@mdi/react'
import { mdiCloudUpload, mdiPlus } from '@mdi/js'

import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

import CustomTable from '../../components/complex/customTable'
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton'
import AddDialog from '../../components/global/addDialog'
import CustomInput from '../../components/basic/input'
import DeleteDialog from '../../components/global/deleteDialog'

import queryString from 'query-string'

import {api} from '../../functions/api'
import { debounce } from 'lodash'


const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class Administrators extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingBtn: false,
            loading: true,
            openSnackbar: false,
            message: "",
            openDialog: false,
            selectedFile: null,
            searchTerm: "",
            is_representative: false,
            role_id: 2,
        }

        this.runningLoop = false;
    }


    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.SHOW,
            url: "edit/tab=2",
            url2: "edit/tab=1"
        },
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
            url: "edit/tab=0"
        },
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.DELETE,
            //url: "delete"
            action: "delete"
        }
    ]

    componentDidMount() {

        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.administrators)
            && toJS(this.props.internal.user.data.permissions.administrators.view)){


            const URLqueryString = this.props.history.location.search
            let queries = queryString.parse(URLqueryString)

            let searchTerm;
            if(queries.searchterm) {
                searchTerm = queries.searchterm;
                this.setState({searchTerm: searchTerm},() => {
                    // this.loadAdministrators();
                })
            }

            this.loadAdministrators();
            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        }
        else {
            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = debounce((searchTerm) => {
        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }, 500)

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadAdministrators()
    }



    loadAdministrators = async (size = 10, page = 0, searchterm = "", by = "last_name", dir = "asc") => {

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {

            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let load_data = await api({
            method:'get',
            url:'administrators',
            authorization: this.props.internal.user.access_token,
            params:{
                searchterm: searchterm,
                page:{
                    number:page,
                    size:size,
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    }
                ]
            }
        })

        if(load_data.success === true) {
            if(load_data.data) {

                for(let i=0; i< load_data.data.data.length; i++) {
                    if(load_data.data.data[i].data) {
                        let phone = load_data.data.data[i].data.phone
                        delete load_data.data.data[i].data.phone
                        load_data.data.data[i].phone = phone
                    }

                }
                this.props.internal.setAdministrators(load_data.data)
                this.props.internal.setDataForTable(load_data.data)

            }
        }
        this.setState({loading: false})
    }

    createNewAdmin = async () => {
        this.setState({loadingBtn: true})
        let first_name = this.first_name.state.value;
        let last_name = this.last_name.state.value;
        let email = this.email.state.value;
        let alt_email = this.alternate_email.state.value;

        if(first_name !== "" && last_name !== "" && email !== "" && alt_email !== "") {

        // let isEmailValid = this.email.getValid('email');

        //if(isEmailValid.success) {
            //if(first_name && last_name && email) {

                let load_data = await api({
                    method:'post',
                    url:'administrators',
                    authorization: this.props.internal.user.access_token,
                    params: {
                        first_name: first_name,
                        last_name: last_name,
                        email: email,
                        is_representative: this.state.is_representative,
                        role_id: this.state.role_id,
                        //passwordy sa nebudu zadavat pri vytvarani noveho administratora
                        password: 123456789,
                        password_confirmation: 123456789,
                        data: {
                            alternate_email: this.alternate_email.state.value,
                            phone: this.phone.state.value,
                            fax: this.fax.state.value
                        },
                        //photo: this.state.selectedFile
                    }

                })

                if(load_data.status === 201) {
                    this.setState({openDialog: false}, () => {
                        this.loadAdministrators();
                        this.props.internal.setSnackbar(load_data.data.message, true)
                    })

                    // this.setState({message: load_data.data.message, openSnackbar: true})
                    //this.props.internal.setSnackbar(load_data.data.message, true)
                }
                else {
                    let resultError = "";
                    if(load_data.data.data.errors) {
                        for(let error in load_data.data.data.errors){
                            resultError += load_data.data.data.errors[error] + " "
                        }
                    }

                    this.props.internal.setSnackbar(resultError, true)
                }

            this.setState({loadingBtn: false})
            this.turnOffSnackBar();
        }
        else {
            let result = ""
            if(first_name === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.NAME_REQUIRED + " ";
            }

            if(last_name === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.LAST_NAME_REQUIRED + " ";
            }

            if(email === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.EMAIL_REQUIRED + " ";
            }

            if(alt_email === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.ALT_EMAIL_REQUIRED + " ";
            }

            this.props.internal.setSnackbar(result, true)
            this.setState({loadingBtn: false})
        }

    }

    handleCloseSnackbar = () => {
        //this.props.internal.setSnackbar("", false);
        this.setState({message: "", openSnackbar: false})
    };



    handleClickOpenDialog = () => {
        this.setState({ openDialog: true });
    };

    handleCloseDialog = () => {
        this.setState({ openDialog: false });
    };

    fileChangedHandler = (event) => {
        this.setState({selectedFile: event.target.files[0]})
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({message: "", openSnackbar: false})
        }, TIMEOUT)
    }

    handleDeleteAdmin = () => {
        this.props.internal.setActionDelete();
        this.deleteAdministrator(this.props.internal.actionDeleteObj.id)
    }

    deleteAdministrator = async (idAdmin) => {
        let delete_data = await api({
            method: 'delete',
            url: 'administrators/' + idAdmin,
            authorization: this.props.internal.user.access_token,
        })

        if (delete_data.success && delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            // this.setState({message: delete_data.data.message, openSnackbar: true})
            let tmpSize = Number(toJS(this.props.internal.administrators.meta.per_page));
            let tmpPage = Number(toJS(this.props.internal.administrators.meta.current_page))
            this.loadAdministrators(tmpSize, tmpPage, "")
            this.turnOffSnackBar();
        }
        else {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            // this.setState({message: delete_data.data.message, openSnackbar: true})
            this.turnOffSnackBar();
        }
    }


    tableHeader = [
        {
            "title":"username",
            "numeric":false,
            sortBy: "last_name",
            "min_width": "125px"
        },
        {
            "title":"email",
            "numeric":false
        },
        {
            "title":"phone",
            "numeric":false,
            "min_width": "125px"
        },
        {
            "title":"clients_count",
            "numeric":true
        },
        {
            title: "role",
            numeric: false
        },
        {
            "title":"available",
            "numeric":false,
            textAlign: "right"
        },
    ];
    tableBody = ["username", "email", "phone", "clients_count", "role", "available"]

    handleChangeIsRepresentative = (event) => {
        this.setState({is_representative: event.target.value})
    }

    handleChangeRole = (event) => {
        this.setState({role_id: event.target.value})
    }

    handleExport = () => {
        api({
            method: 'get',
            url: 'users/export',
            authorization: this.props.internal.user.access_token,
        }).then(result => {
            if (true === result.success) {
                window.open(result.data.data.link, '_blank');
            }
        });
    }

    render() {
        let permissions;

        if (!this.state.loading) {
            permissions = toJS(this.props.internal.user.data.permissions.administrators )
        }

        return (

            <div className={'administrators'}>
            <DeleteDialog
                    open={this.props.internal.actionDelete}
                    title={this.props.translate.i18n.MODULES.ADMINISTRATORS.DELETE_ADMIN_TITLE}
                    content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                    btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                    delete={this.handleDeleteAdmin}
            />
            <AddDialog
                open={this.state.openDialog}
                onClose={this.handleCloseDialog}
                title={this.props.translate.i18n.MODULES.ADMINISTRATORS.CREATE_NEW_ADMIN.TITLE}
                >
                <DialogContent  className={'add-administrator'}>
                <div className="flex">
                    <CustomInput
                        ref={ref => this.first_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.FIRST_NAME}
                        id={'firstname'}
                        className={"mr-10"}
                        required
                    />
                    <CustomInput
                        ref={ref => this.last_name = ref}
                        text={this.props.translate.i18n.GLOBAL.USER.LAST_NAME}
                        id={'lastname'}
                        required
                    />
                </div>
                <div className="flex-column">
                    <CustomInput
                        ref={ref => this.email = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                        id={'email'}
                        className={"w-100"}
                        required
                    />
                    <CustomInput
                        ref={ref => this.alternate_email = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.ALTERNATE_EMAIL}
                        id={'email-alternative'}
                        className={"w-100"}
                        required
                    />
                    <CustomInput
                        ref={ref => this.phone = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                        id={'phone'}
                        className={"w-100"}
                    />
                    <CustomInput
                        ref={ref => this.fax = ref}
                        text={this.props.translate.i18n.GLOBAL.CONTACT.FAX}
                        id={'fax'}
                        className={"w-100"}
                    />
                    {/* <div className={'flex space-between isRepresentative'}>
                        <span className={'label'}>{this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_REPRESENTATIVE}</span>
                        <Switch
                            // disabled={data.disabled || this.props.disableEdit}
                            checked={this.state.is_representative}
                            onChange={this.handleChangeIsRepresentative}
                            value="is_representative"
                            classes={{
                                switchBase: 'switchBase',
                                checked: 'checked',
                                bar: 'switch-bar'
                            }}
                        />
                    </div> */}
                    <FormControl className='tags-selector min-width-200'>
                        <InputLabel htmlFor="isRepresentative" className={'label-select-tag'}>{this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_ROLE}</InputLabel>
                        <Select
                            className={'multiple-select '}
                            value={this.state.role_id}
                            onChange={this.handleChangeRole}
                            inputProps={{
                                name: 'isRepresentative',
                                id: 'isRepresentative',
                            }}
                            // renderValue={() => {return(<span>{this.state.is_representative}</span>)}}
                        >
                            <MenuItem value={2} defaultChecked={true}>{this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMINISTRATOR}</MenuItem>
                            <MenuItem value={5}>{this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_REPRESENTATIVE}</MenuItem>
                            <MenuItem value={6}>{this.props.translate.i18n.MODULES.PRIVILEGES.WAREHOUSE}</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCloseDialog} className={'btn-boulder-text'}>
                    {this.props.translate.i18n.MODULES.ADMINISTRATORS.CREATE_NEW_ADMIN.CANCEL}
                    </Button>
                    <CustomButton
                            justText
                            progressBar={this.state.loadingBtn}
                            onClick={this.createNewAdmin}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.MODULES.ADMINISTRATORS.CREATE_NEW_ADMIN.ADD}
                        />
                </DialogActions>
            </AddDialog>
            <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} onClose={this.handleCloseSnackbar}/>

                {this.state.loading ?
                    null
                    :
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.ADMINISTRATORS.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        <div className={'flex-end'}>
                            {permissions.export ? (<CustomButton
                              mystyle={'btn-orange-bg border-radius-18'}
                              title={this.props.translate.i18n.GLOBAL.MENU.EXPORT}
                              onClick={() => this.handleExport()}
                            >
                                <Icon path={mdiCloudUpload} size={1}  />
                            </CustomButton>) : null}
                            <CustomButton
                              mystyle={'btn-orange-bg border-radius-18'}
                              title={this.props.translate.i18n.MODULES.ADMINISTRATORS.CREATE_NEW}
                              onClick={this.handleClickOpenDialog}
                            >
                                <Icon path={mdiPlus} size={1}  />
                            </CustomButton>
                        </div>
                    </div>
                }
                {this.state.loading ?
                    <CircularProgress className={'circular-progress'} />
                    :
                   <CustomTable
                        dropDownMenuItems={this.dropDownMenuItems}
                        module={'/administrators'}
                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                        handleChangePage={this.handleChangePage}
                        handleSort={this.handleSort}
                        header={this.tableHeader}
                        body={this.tableBody}
                        >

                    </CustomTable>
                   }

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/administrators/index.js